import { API } from 'utils/Helper';

export const fetchIpInfo = async () => {
  const response = await fetch("https://ipinfo.io/json");
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const verifyReferralCode = async (code) => {
  const response = await fetch(`${API}/verify-referral-code/${code}`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};

export const getSiteSettings = async () => {
  const response = await fetch(`${API}/setting`);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
};
